// extracted by mini-css-extract-plugin
export default {"root":"RMGzJ","header":"SPtpT"};